import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageMeta = ({ 
  title, 
  description, 
  path = '/',
  image = 'https://mheorthodox.org/logo512.png'
}) => {
  const baseTitle = 'Mekane Hiwet Eyesus Dallas Orthodox Tewahdo Church';
  const fullTitle = title ? `${title} – ${baseTitle}` : baseTitle;
  const defaultDescription = 'Mekane Hiwet Eyesus Dallas Orthodox Tewahdo Church in Dallas, TX – worship schedule, sermons, ministries, and resources for our church community and families.';
  const metaDescription = description || defaultDescription;
  const url = `https://mheorthodox.org${path}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default PageMeta;
